import { Table } from "components/Table/Table";
import {
  BoxStyle,
  ButtonBlue,
  DarkHeading,
  DashboardBoxStyle,
  Paragraph,
  PinkButton,
  SpanYellow,
  YellowButton,
  YellowHeading,
} from "components/common/CommonStyles";
import React, { useEffect, useState } from "react";
import { PracticeCardData } from "../data";
import { useNavigate } from "react-router";
import PracticeInterviewCard from "../../../components/Card/PracticeInterviewCard";
import { Spinner } from "react-bootstrap";
import { GetIntervieweeDetails, GetStudentsDetails } from "../../../axios/apis";
import { toast, Toaster } from "react-hot-toast";
import { ToastStyles } from "components/common/ToastStyle";
import Moment from "react-moment";
import Loading from "components/common/Loading";

export const MyInterview = () => {
  const navigate = useNavigate();
  const [favinterview, setfavInverView] = useState(false);
  const [loading, setLoading] = useState(true);
  const [interview, setInterView] = useState({
    id: "",
    data: [],
  });
  const [allInterview, setAllInterview] = useState({
    id: "",
    data: [],
  });
  const [uniqueInterView, setUniqueInterView] = useState({
    id: "",
    data: [],
  });

  const GetAllInterviews = async () => {
    setLoading(true);
    try {
      let interviewList = [];
      const response = await GetStudentsDetails();
      // console.log(response?.data?.data?.interviewResults)
      const unique = [
        ...new Map(
          response?.data?.data?.interviewResults.map((item) => [
            item?.interview_id?._id,
            item,
          ])
        ).values(),
      ];
      unique?.forEach((interview) => {
        interviewList.push({
          ...interview,
          isUnique: true,
        });
      });
      setUniqueInterView({
        id: "table1",
        data: interviewList?.slice()?.reverse(),
      });
      setInterView({
        id: "allTable",
        data: response?.data?.data?.interviewResults?.slice()?.reverse(),
      });
      setAllInterview({
        id: "table1",
        data: interviewList?.slice()?.reverse(),
      });
      setLoading(false);
    } catch (error) {
      console.log(error);
      toast.error("Try Again", ToastStyles);
      setLoading(false);
    }
  };

  useEffect(() => {
    GetAllInterviews();
  }, []);

  // console.log(allInterview);

  const columns = [
    // {
    //   field: "description", headerName: "JD", minWidth: "150", renderCell: (params) => (
    //     <div className="d-flex align-items-center">hello</div>
    //   ),
    // },
    // {
    //   field: "company",
    //   headerName: "CREATED BY",
    //   minWidth: "150", renderCell: (params) => (
    //     <div className="d-flex align-items-center">{params?.row?.interview_id?.company}</div>
    //   ),
    // },
    // {
    //   field: "icon",
    //   headerName: "",
    //   minWidth: "50",
    //   renderCell: (params) => (
    //     <div className="d-flex align-items-center">
    //       <img
    //         className="user-img"
    //         src={params?.row?.interview_id?.icon}
    //         alt="logo"
    //       />
    //     </div>
    //   ),
    // },

    {
      field: "jobcategory",
      headerName: "JOB CATEGORY",
      minWidth: "150",
      renderCell: (params) => (
        <div className="d-flex align-items-center">
          {params?.row?.interview_id?.jobcategory}
        </div>
      ),
    },
    {
      field: "jobtitle",
      headerName: "JOB ROLE",
      minWidth: "220",
      renderCell: (params) => (
        <div className="d-flex align-items-center">
          {params?.row?.interview_id?.jobtitle}
        </div>
      ),
    },
    // {
    //   field: "experience",
    //   headerName: "EXPERIENCE",
    //   minWidth: "150",
    //   renderCell: (params) => (
    //     <div className="d-flex align-items-center">
    //       {params?.row?.interview_id?.experience}
    //     </div>
    //   ),
    // },
    {
      field: "domain",
      headerName: "INDUSTRY",
      minWidth: "150",
      renderCell: (params) => (
        <div className="d-flex align-items-center">
          {params?.row?.interview_id?.domain}
        </div>
      ),
    },
    // {
    //   field: "createdAt",
    //   headerName: "Submitted",
    //   minWidth: "150", renderCell: (params) => (
    //     <div className="d-flex align-items-center">{params?.value.slice(0,10)}</div>
    //   ),
    // },
    {
      field: "reports",
      headerName: "Reports",
      minWidth: "150",
      renderCell: (data) => (
        <div
          onClick={() => {
            if (data?.row?.isUnique) {
              setAllInterview({
                id: "table2",
                data: interview?.data?.filter(
                  (item) =>
                    item?.interview_id?._id === data?.row?.interview_id?._id
                ),
              });
            } else {
              navigate(`/college-student/reports/${data.row._id}`);
            }
          }}
          className="d-flex align-items-center text-hover"
        >
          View
        </div>
      ),
    },
  ];
  const columns2 = [
    // {
    //   field: "icon",
    //   headerName: "",
    //   minWidth: "50",
    //   renderCell: (params) => (
    //     <div className="d-flex align-items-center">
    //       <img
    //         className="user-img"
    //         src={params?.row?.interview_id?.icon}
    //         alt="logo"
    //       />
    //     </div>
    //   ),
    // },

    {
      field: "updatedAt",
      headerName: "Date of Attempt",
      minWidth: "150",
      renderCell: (params) => (
        <div className="d-flex align-items-center">
          <Moment format="DD/MM/YYYY" date={params?.value} />
        </div>
      ),
    },
    {
      field: "createdAt",
      headerName: "Time of Attempt",
      minWidth: "150",
      renderCell: (params) => (
        <div className="d-flex align-items-center">
          <Moment format="hh:mm A" date={params?.value} />
        </div>
      ),
    },
    // {
    //   field: "videoscore",
    //   headerName: "Video Score",
    //   minWidth: "150",
    //   renderCell: (params) => (
    //     <div className="d-flex align-items-center">100</div>
    //   ),
    // },
    {
      field: "video",
      headerName: "Video",
      minWidth: "150",
      renderCell: (params) => (
        <SpanYellow
          onClick={() =>
            navigate(`/college-student/interview-video/${params?.row?._id}`)
          }
        >
          View
        </SpanYellow>
      ),
    },
    {
      field: "reports",
      headerName: "Reports",
      minWidth: "150",
      renderCell: (data) => (
        <div
          onClick={() => {
            if (data?.row?.isUnique) {
              setAllInterview({
                id: "table2",
                data: interview?.data?.filter(
                  (item) =>
                    item?.interview_id?._id === data?.row?.interview_id?._id
                ),
              });
            } else {
              navigate(`/college-student/reports/${data.row._id}`);
            }
          }}
          className="d-flex align-items-center text-hover"
        >
          View
        </div>
      ),
    },
  ];
  return (
    <>
      <Toaster />
      {loading ? (
        <DashboardBoxStyle className="scroller d-flex align-items-center justify-content-center">
          <Loading />
        </DashboardBoxStyle>
      ) : (
        <DashboardBoxStyle className="scroller">
          <div className="container">
            <BoxStyle className="my-1 py-3 px-4">
              <div className="d-flex justify-content-between">
                <YellowHeading>My Interview</YellowHeading>
                {allInterview.id !== "table1" && (
                  <ButtonBlue
                    onClick={() => setAllInterview(uniqueInterView)}
                    className="px-4"
                  >
                    All Interview
                  </ButtonBlue>
                )}
              </div>
              {/* <div
            className="d-flex align-items-center mb-3"
            style={{ marginTop: "10px" }}
          >
            <ButtonBlue
              className={`px-2 h-40 ${
                favinterview ? "" : "inactive"
              }`}
              onClick={() => {
                setfavInverView(false)
              }}
            >
              Interview Courses
            </ButtonBlue>
            <YellowButton
              className={`mx-2 ${interview.jobInterview ? "px-2 active" : ""}`}
              onClick={() => {
                setInverView({
                  interviewCourses: false,
                  jobInterview: !interview.jobInterview,
                  favoriteCourses: false,
                });
              }}
            >
              Job Interviews
            </YellowButton>
            <YellowButton
              className={`mx-2 ${
                favinterview ? "px-2 active" : ""
              }`}
              onClick={() => {
                setfavInverView(true)
              }}
            >
              Favourite
            </YellowButton>
          </div> */}
              {!favinterview && (
                <Table
                  columns={allInterview?.id === "table1" ? columns : columns2}
                  checkbox={false}
                  data={allInterview?.data?.map((item) => {
                    return {
                      ...item,
                      id: item._id,
                      key: item._id,
                    };
                  })}
                  limit={10}
                />
              )}
              {/* {favinterview &&
            PracticeCardData.map((item, index) => (
              <PracticeInterviewCard item={item} />
            ))} */}
            </BoxStyle>
          </div>
        </DashboardBoxStyle>
      )}
    </>
  );
};
